<template>
  <div :class="`Custom container ${dialog ? '':'h-100'}`">
    <div v-if="!dialog" class="content">
      <div class="header">
        <el-form :model="searchCondition" :inline="true" class="form" size="mini">
          <el-form-item label="客户名称">
            <el-input v-model="searchCondition.name" placeholder="请输入客户名称"
                      @change="onSubmit"/>
          </el-form-item>
          <el-form-item label="集团名称">
            <el-input v-model="searchCondition.combine_name" placeholder="请输入集团名称"
                      @change="onSubmit"/>
          </el-form-item>
          <el-form-item label="开拓者">
            <PinYinMatchSelect :data="optionsMap.saleOption" :isMultiple="true"
                               placeholder="请输入开拓者"
                               :model-value.sync="searchCondition.pioneer_id"
                               @change="getSaleId" @focus="getOptionSales" style="width: 180px"/>
            <!--            <el-input v-model="searchCondition.pioneer_id" placeholder="请输入开拓者"-->
            <!--                      @change="onSubmit"/>-->
          </el-form-item>
          <el-form-item label="是否年框">
            <el-checkbox-group v-model="searchCondition.year_frame" @change="onSubmit">
              <el-checkbox label="Y">年框</el-checkbox>
              <el-checkbox label="N">非年框</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="合作状态">
            <el-checkbox-group v-model="searchCondition.is_new" @change="onSubmit">
              <el-checkbox label="U">未合作</el-checkbox>
              <el-checkbox label="Y">新客</el-checkbox>
              <el-checkbox label="N">老客</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="录入时间">
            <el-date-picker
                v-model="searchCondition.timeRange"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                style="width: 300px;margin-top: 1px;"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="el-button--operation"
                       style="margin-left:20px;" @click="onSubmit">查询
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="onReset" style="margin-right:0;">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="page-main" style="height: calc(100% - 85px)">
        <div style="margin-bottom: 8px;display: flex;justify-content: space-between;">
          <div>
            <el-button size="mini" type="primary" @click="goAdd"
                       v-if="userAuth.can_store_basic_customer" icon="el-icon-plus">添加客户
            </el-button>
            <el-button @click="mergeCustomer" size="mini" type="primary" plain icon="el-icon-connection"
                       v-if="userAuth.can_merge_basic_customer" style="margin-right: 10px;">合并客户
            </el-button>
            <export-btn size="mini" :can-export="userAuth.can_export_customer_info"
                        @export="exportExcel('refExportBtn')" ref="refExportBtn" :lint-title="`导出客户`"/>
            <el-button type="danger" :underline="false"
                       style="margin-left: 10px;"
                       size="mini"
                       @click="batchDelete"
                       v-if="userAuth.can_delete_customer_info" :disabled="selectList.length===0">
              <i class="el-icon-delete"/>&nbsp;&nbsp;删除客户
            </el-button>
          </div>
          <div>

            <el-popover
                style="position: absolute;right: 40px;"
                placement="bottom"
                width="600"
                trigger="click">
              <el-table :data="hideData" style="width: 100%" class="data-table">
                <el-table-column width="200" property="name" :show-overflow-tooltip="true"
                                 label="客户名称"/>
                <el-table-column width="100" property="email" :show-overflow-tooltip="true" label="原因">
                  <template slot-scope="scope">
                    <span v-if="scope.row.is_deleted">删除</span>
                    <span v-else>合并到【{{ scope.row.to_name }}】</span>
                  </template>
                </el-table-column>
                <el-table-column width="120" property="deleted_at" :show-overflow-tooltip="true"
                                 label="时间" align="center"/>
                <el-table-column width="150" label="操作">
                  <template slot-scope="scope">
                    <el-button
                        style="padding: 0 0"
                        type="text"
                        size="mini"
                        @click="undoHandle(scope.row)"
                    >撤销[{{ scope.row.is_deleted ? '删除' : '合并' }}]
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination class="custom-page"
                             style="text-align: right"
                             small
                             layout="prev, pager, next"
                             @current-change="handleHideListCurrentChange"
                             :current-page="hideListParams.page"
                             :total="hideListParams.total"
                             :page-size="20"
              >
              </el-pagination>
              <div
                  style="margin-right:20px;"
                  slot="reference"
                  class="default-button d-flex-row align-items-center"
                  @click="getHideDataList"
              >
                回收站
              </div>
            </el-popover>
          </div>
        </div>
        <!--   table列表     -->
        <div class="default-table" style="height: calc(100% - 65px);">
          <ApeTable ref="apeTable"
                    :data="dataList"
                    :columns="columns"
                    :loading="loadingStatus"
                    :pagingData="pagingData"
                    :isFullHeight="true"
                    @switchPaging="switchPaging"
                    @selectList="handleSelectionChange"
                    @changeTableSort="changeTableSort"
                    highlight-current-row
                    border>
            <el-table-column
                slot="first-column"
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column
                slot="first-column"
                width="60"
                label="序号">
              <template slot-scope="scope">
                <span>{{ offset + scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
                slot="second-column"
                prop="name"
                label="客户名称"
                header-align="center"
                align="left"
                min-width="280"
                :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="`ID:${scope.row.id}`" placement="right">
                  <el-link type="primary" @click="jumpToDetail(scope.row.id)">
                    {{ scope.row.name }}
                  </el-link>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
                slot="second-column"
                label="集团"
                header-align="center"
                align="center"
                min-width="100"
                :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                {{ scope.row.combine ? scope.row.combine.name : '--' }}
              </template>
            </el-table-column>
            <el-table-column
                slot="second-column"
                prop="pioneer_id"
                label="开拓者"
                header-align="center"
                align="center"
                min-width="100"
                sortable="custom"
                :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                {{ scope.row.pioneer_name || '--' }}
              </template>
            </el-table-column>
            <el-table-column
                slot="second-column"
                prop="credit"
                label="信用"
                header-align="center"
                align="center"
                min-width="100"
                sortable="custom"
                :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <store-credit :data="scope.row" @success="onSubmit"/>
              </template>
            </el-table-column>
            <el-table-column
                slot="second-column"
                prop="year_frame"
                label="年框"
                header-align="center"
                align="center"
                min-width="80"
                :show-overflow-tooltip="true"
                sortable="custom"
            >
              <template slot-scope="scope">
                <span class="span-btn" @click="handelToYearFrame(scope.row)">
                  <template v-if="scope.row.year_frame === 'Y'"><i class="el-icon-star-on"/>年框</template>
                  <template v-else><i class="el-icon-star-off"/>非年框</template>
                </span>
              </template>
            </el-table-column>
            <el-table-column
                slot="second-column"
                prop="is_new"
                label="新客"
                header-align="center"
                align="center"
                min-width="100"
                sortable="custom"
                :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.is_new === 'Y'"><i class="el-icon-star-on"></i>是</span>
                <span v-else-if="scope.row.is_new === 'N'"><i class="el-icon-star-off"></i>否</span>
                <span v-else>未合作</span>
              </template>
            </el-table-column>

            <el-table-column
                slot="second-column"
                prop="sign_begin"
                label="签约开始"
                header-align="center"
                align="left"
                min-width="120"
                sortable="custom"
                :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                {{ scope.row.sign_begin }}
              </template>
            </el-table-column>
            <el-table-column
                slot="second-column"
                prop="sign_end"
                label="签约截至"
                header-align="center"
                align="left"
                min-width="120"
                sortable="custom"
                :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                {{ scope.row.sign_end }}
              </template>
            </el-table-column>
            <el-table-column
                slot="second-column"
                prop="first_trade_at"
                label="首单时间"
                header-align="center"
                sortable="custom"
                align="center"
                min-width="110"
                :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                {{ $utils.parseTime(scope.row.first_trade_at,'{y}-{m}-{d}') }}
              </template>
            </el-table-column> <el-table-column
                slot="second-column"
                prop="first_trade_at"
                label="最近交易时间"
                header-align="center"
                sortable="custom"
                align="center"
                min-width="120"
                :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                {{ $utils.parseTime(scope.row.last_trade_at,'{y}-{m}-{d}') }}
              </template>
            </el-table-column>
            <el-table-column
                slot="second-column"
                prop="invoice_title"
                label="发票抬头"
                header-align="center"
                align="left"
                min-width="140"
                :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                {{ scope.row.invoice_title }}
              </template>
            </el-table-column>


            <el-table-column
                slot="second-column"
                prop="invoice_type"
                label="发票类型"
                header-align="center"
                align="center"
                min-width="140"
                :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.invoice_type === 'common_invoice'">电子普票</span>
                <span v-else>电子专票</span>
              </template>
            </el-table-column>
            <!--                <el-table-column-->
            <!--                    slot="second-column"-->
            <!--                    prop="first_trade_at"-->
            <!--                    label="首单时间"-->
            <!--                    header-align="center"-->
            <!--                    align="center"-->
            <!--                    min-width="110"-->
            <!--                    :show-overflow-tooltip="true"-->
            <!--                >-->
            <!--                </el-table-column>-->

            <el-table-column
                label="操作" width="180" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" @click="goEdit(scope.row)" size="mini"
                           :disabled="!(userAuth.can_store_basic_customer)">
                  <i class="el-icon-edit"></i>编辑
                </el-button>
                <el-button type="text" @click="rowDel([scope.row])" size="mini"
                           :disabled="!(userAuth.can_delete_basic_customer)" class="delete-btn">
                  <i class="el-icon-delete"></i>删除
                </el-button>
                <el-button type="text" @click="goExecCorp(scope.row)" size="mini"
                           :disabled="!(userAuth.can_store_basic_customer)" class="corp-btn">
                  <i class="el-icon-paperclip"></i>执行公司
                </el-button>
              </template>
            </el-table-column>
          </ApeTable>
        </div>

        <div style="text-align: left">
          <span style="color: #E6A23C"> PS：发票信息来自销售录入的最新开票新增</span>
        </div>
      </div>

      <el-dialog :title="dialogStoreType === 'add' ? '添加客户' : '编辑客户'" :visible.sync="dialogStoreBool"
                 custom-class="dialog-store-customer"
                 @close="DialogClosed">
        <el-form :model="storeForm" :rules="rules" ref="storeForm" label-width="80px"
                 style="text-align:left;">
          <el-form-item prop="name" label="客户名称">
            <el-input v-model="storeForm.name" placeholder="请输入客户名称" show-word-limit maxlength="100" clearable
                      size="mini"/>
          </el-form-item>
          <el-form-item label="主动开拓">
            <el-radio v-model="storeForm.is_pioneer" label="Y">是</el-radio>
            <el-radio v-model="storeForm.is_pioneer" label="N">否</el-radio>
          </el-form-item>
          <el-form-item label="开拓者" v-if="storeForm.is_pioneer === 'Y'">
            <PinYinMatchSelect :data="optionsMap.saleOption"
                               placeholder="销售"
                               :model-value.sync="storeForm.pioneer_id"
                               @change="getSaleId" @focus="getOptionSales" style="width: 100%"/>
          </el-form-item>
          <el-form-item label="集团">
            <el-select v-model="storeForm.combine" filterable default-first-option remote clearable
                       :remote-method="handelRemoteCombine"
                       size="mini" style="width: calc(100% - 60px);margin-right: 10px;" placeholder="请选择集团">
              <el-option v-for="item in combineOptions" :key="item.id" :label="item.name" :value="item.id"/>
            </el-select>
            <el-button type="text" size="mini" @click="handelManageCombine">管理集团</el-button>
          </el-form-item>
          <el-form-item label="信用">
            <el-input v-model="storeForm.credit" placeholder="请输入信用" type="textarea" maxlength="50"
                      show-word-limit/>
          </el-form-item>
          <div style="text-align:center;">
            <button-submit ref="buttonSubmit"
                           :button-txt="dialogStoreType === 'add' ? '添加' : '保存'" style="margin-right: 50px;"
                           :disabled="!storeForm.name" @click.native.prevent="doStore"/>
            <el-button @click="dialogStoreBool = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
      <el-dialog title="合并客户" :visible.sync="dialogMergeCustomerBool">
        <el-alert type="warning" class="custom-alert" :closable="false">
          <template slot='title'>
            <div style="font-weight: bold;text-align: left;">注意:<br/>{{ '\u3000\u3000' }}请仔细核对信息无误，操作不可撤回
            </div>
            <br/>
            <div style="text-align: left;">即将合并&nbsp;
              <el-select
                  style="width: 300px"
                  v-model="mergeForm.customers"
                  multiple
                  filterable
                  remote
                  size="mini"
                  reserve-keyword
                  placeholder="请输入关键词"
                  :remote-method="remoteMethod"
                  :loading="loading"
                  @change="changeMergeCustomers"
              >
                <el-option
                    v-for="item in customerMultipleOptions"
                    :key="item.custom_value"
                    :label="item.name"
                    :value="item.custom_value">
                </el-option>
              </el-select>
              至
              <el-select class="el-input-c" v-model="mergeForm.basic_customer_id"
                         ref="customerBasicSelect" filterable
                         clearable
                         size="mini"
                         @keyup.native.prevent="inputBasicCustomer"
                         @change="changeBasicCustomer"
                         placeholder="请选择客户名称">
                <el-option
                    v-for="item in customerBasicOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div style="text-align: left;">
              合并后将删除 【{{ mergeForm.customer_names }}】，统一归属于 【{{ mergeForm.basic_customer_name }}】
            </div>
          </template>
        </el-alert>
        <button-submit ref="buttonSubmit" button-txt="确认" style="margin-top: 10px;" type="danger"
                       :disabled="!mergeForm.customer_ids||!mergeForm.basic_customer_id"
                       @click.native.prevent="doMergeCustomer"/>
        <el-button style="margin-top: 10px;" @click="dialogMergeCustomerBool = false">取消</el-button>
      </el-dialog>
      <!-- 执行公司 -->
      <el-dialog :title="`绑定执行公司`" :visible.sync="dialogExecCorp.show"
                 custom-class="dialog-store-customer"
                 @close="dialogClosedExecCorp">
        <div>
          <el-form :model="dialogExecCorp.form" :inline="true" class="form" size="mini">
            <el-form-item>
              <div>
                <el-select v-model="dialogExecCorp.form.corp_id"
                           filterable
                           remote
                           placeholder="请输入公司名称"
                           :remote-method="querySearchAsync"
                           :loading="dialogExecCorp.selectLoading"
                >
                  <el-option
                      v-for="item in dialogExecCorp.selectList"
                      :key="item.id"
                      :label="item.value"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="el-button--operation" style="margin-left:20px;" @click="onSubmitExecCorp">
                绑定
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="el-button--operation corp-refresh-btn" style="margin-left:20px;" @click="getExecCorpList(dialogExecCorp.form.customer_id)">
                <i class="el-icon-refresh"></i>
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="default-table" style="height: 500px;margin-bottom: 20px;">
          <ApeTable ref="execCorpTable"
                    :data="dialogExecCorp.data"
                    :columns="dialogExecCorp.columns"
                    :loading="dialogExecCorp.loading"
                    :pagingData="dialogExecCorp.pagingData"
                    :isFullHeight="true"
                    @switchPaging="switchExecCorpPaging"
                    highlight-current-row
                    border>
            <el-table-column
                label="操作" width="180" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" @click="onDeleteExecCorp(scope.row)" size="mini" class="delete-btn">
                  <i class="el-icon-delete"></i>删除
                </el-button>
              </template>
            </el-table-column>
          </ApeTable>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>

import {
  addOrEditCustom,
  getCustomerSearchOption,
  getCustomerOption,
  isExit,
  postMergeCustomer,
  getCustomersHideList,
  postUndoHandel,
  deleteCustom,
  getCustomersList,
  exportCustomers,
  getCustomerExecCorpList,
  storeExecCorp,
  deleteExecCorp,
  customerSearch
} from "@/api/customers";
import ApeTable from "@/components/ApeTable";
import ExportBtn from "@/components/export/ExportBtn";
import StoreCredit from "./components/StoreCredit";
import {saleOptions} from '@/api/user'
import {shortcutsDateOptions} from "@/config/business";
import {combineCustomerLikeQuery} from "@/api/combine";


export default {
  name: "index",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    pid: Number
  },
  components: {
    ExportBtn,
    ApeTable,
    StoreCredit,
  },
  data() {
    const _this = this
    const validateName = function (rule, value, callback) {
      let data = {name: value}
      if (_this.storeForm.id) {
        data.id = _this.storeForm.id
      }
      if (!value) {
        return callback(new Error('请输入客户名称'));
      }
      isExit(data).then(() => {
        callback()
      }).catch(err => {
        return callback(new Error(err));
      });
    }
    return {
      optionsMap: {
        saleOption: []
      },
      searchCondition: {name: null, combine_name: null, year_frame: [], is_new: [], timeRange: [], pioneer_id: []},
      orderBy: 'id desc',
      pickerOptions: shortcutsDateOptions,
      combineOptions: [],// 集团下拉
      loadingStatus: false,
      // 表格列表数据
      dataList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 20,
        // offset: 0
      },
      // 分页的offset,序号列使用
      offset: 0,
      columns: [
        {
          title: '税号',
          value: 'tax_id',
          header_align: 'center',
          width: 140
        },
        {
          title: '客户电话',
          value: 'telephone',
          header_align: 'center',
          align: 'left',
          width: 100
        },
        {
          title: '详细地址',
          value: 'address',
          header_align: 'center',
          align: 'left',
          width: 140
        },
        // {
        //   title: '发票类型',
        //   value: 'invoice_type',
        //   header_align: 'center',
        //   width: 140
        // },
        {
          title: '发票内容',
          value: 'invoice_content',
          header_align: 'center',
          width: 140
        },
        {
          title: '开户行',
          value: 'bank_name',
          width: 100,
          header_align: 'center',
          align: 'center',
        },

        {
          title: '创建时间',
          value: 'created_at',
          header_align: 'center',
          align: 'center',
          width: 110
        },
        {
          title: '修改时间',
          value: 'updated_at',
          header_align: 'center',
          align: 'center',
          width: 110
        },
      ],

      dialogStoreBool: false,
      dialogMergeCustomerBool: false,
      tableLoading: true,
      dialogStoreType: 'add',
      storeForm: {
        id: '',
        name: '',
        pid: 0,
        pioneer_id: null,
        credit: null,
        is_pioneer: 'Y',
        combine: null,
      },
      mergeForm: {
        customers: [],
        customer_names: '',
        customer_ids: '',
        basic_customer_id: '',
        basic_customer_name: '',
      },
      rules: {
        name: [
          {required: true, trigger: 'blur', validator: validateName},
        ]
      },
      custom: {
        customer_name: "", //客户名称
      },
      params: {
        page: 1,
        per_page: 15,
        total: 0
      },
      theadData: [],
      tableData: [],
      selectList: [],
      sort: {
        order: '',
        prop: ''
      },
      mergeCustomerIds: [],
      customerOptions: [],
      customerMultipleOptions: [],
      customerBasicOptions: [],
      customerTimestamp: false,
      loading: false,
      hideData: [],
      hideListParams: {
        page: 1,
        total: 0
      },
      currentCustomer: {},
      dialogExecCorp: {
        show: false,
        loading: true,
        title: '',
        data: [],
        pagingData: {
          is_show: true,
          layout: 'total, sizes, prev, pager, next, jumper',
          total: 0,
          page_size: 15,
        },
        selectLoading: false,
        selectList: [],
        columns: [
          { title: '客户名称', value: 'customer_nm', header_align: 'center', width: 140},
          { title: '执行公司名称', value: 'corp_nm', header_align: 'center', width: 140},
          { title: '创建时间', value: 'created_at', header_align: 'center', align: 'center', width: 110},
        ],
        form: {
          customer_id: null,
          corp_id: null,
          corp_nm: ''
        }
      }
    }
  },
  created() {
      this.getCustomerOption()
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth
    }
  },
  mounted() {
    this.initList();
    // this.getHideDataList();
  },
  methods: {
    DialogClosed() {
      this.searchCondition.sale_id = ''
    },
    getSaleId() {
      // this.storeForm.pioneer_id = this.searchCondition.sale_id
    },
    //销售
    getOptionSales() {
      if (this.optionsMap.saleOption.length === 0) {
        saleOptions().then(res => {
          this.optionsMap.saleOption = res.model;
        });
      }
    },
    changeTableSort({prop, order}) {
      // let orderSort = {}
      // if (order) {
      //   orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      // }
      this.orderBy = `\`${prop}\` ${order === 'descending' ? 'desc' : 'asc'}`
      this.initList()
    },
    // 勾选事件
    handleSelectionChange(val) {
      this.selectList = val
    },
    jumpToDetail(id) {
      const {href} = this.$router.resolve({
        name: `detailCustom`,
        query: {id: id}
      });
      window.open(href, "_blank");
    },

    // 切换页码操作
    async switchPaging() {
      await this.initList()
    },
    async initList(type) {
      this.loadingStatus = true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition, pagingInfo, {orderBy: this.orderBy})

      let {list, pages} = await getCustomersList(searchCondition).then(res => {
        return res.model
      })

      this.$nextTick(() => {
        this.dataList = list
      })

      this.pagingData.total = pages.total
      this.offset = pages.offset

      this.loadingStatus = false

    },

    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}

      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name
      }
      if (this.searchCondition.year_frame && this.searchCondition.year_frame.length > 0) {
        condition.year_frame = this.searchCondition.year_frame
      }

      if (this.searchCondition.is_new && this.searchCondition.is_new.length > 0) {
        condition.is_new = this.searchCondition.is_new
      }

      if (this.searchCondition.timeRange && this.searchCondition.timeRange.length === 2) {
        condition.start_at = this.searchCondition.timeRange[0]
        condition.end_at = this.searchCondition.timeRange[1]
      }
      if (this.searchCondition.pioneer_id && this.searchCondition.pioneer_id.length > 0) {
        condition.pioneer_id = this.searchCondition.pioneer_id
      }
      if (this.searchCondition.combine_name) {
        condition.combine_name = this.searchCondition.combine_name
      }

      return condition
    },

    doStore() {
      const that = this
      this.$refs['storeForm'].validate(async (valid) => {
        if (valid) {
          const response = await addOrEditCustom(this.storeForm);
          if (!response.success) {
            this.showToast({h: that, icon: "el-icon-error", text: response.message, duration: 3000});
            return;
          }
          this.showToast({h: that, icon: "el-icon-success", text: '操作成功', duration: 2000});
          this.onSubmit();
          this.dialogStoreBool = false
        }
      })
    },
    onSubmit() {
      this.$refs['apeTable'].handleCurrentChange(1)
      // this.initList();
    },
    // 重置
    onReset() {
      this.searchCondition = {name: null, year_frame: [], is_new: [], timeRange: [], pioneer_id: []}
      this.$refs['apeTable'].handleCurrentChange(1)
      // this.initList()
    },
    goAdd() {
      this.dialogStoreBool = true
      this.dialogStoreType = 'add'
      this.storeForm.name = ''
      this.storeForm.id = ''
      this.storeForm.pid = ''
      this.storeForm.pioneer_id = null
      this.storeForm.credit = null
      this.storeForm.combine = null
    },
    // 去编辑
    goEdit(row) {
      this.dialogStoreBool = true
      this.dialogStoreType = 'edit'
      this.storeForm.name = row.name
      this.storeForm.id = row.id
      this.storeForm.pioneer_id = parseInt(row.pioneer_id)
      this.storeForm.credit = row.credit
      this.storeForm.combine = row.combine ? row.combine.name : null
    },
    // 被选择的表格项删除
    async setDeleteRow() {
      let _idList = [];
      for (let index = 0; index < this.selectList.length; index++) {
        _idList.push(this.selectList[index].id);
      }
      const response = await deleteCustom({ids: _idList})
      if (!response.success) {
        this.showToast({
          h: this,
          icon: "el-icon-error",
          text: response.message,
          duration: 2000
        })
        return false
      }

      this.showToast({
        h: this,
        icon: "el-icon-success",
        text: "删除成功",
        duration: 2000
      });
      this.onSubmit();
    },
    batchDelete() {
      let len = this.selectList.length
      if (len > 0) {
        let that = this;
        this.showModal({
          h: this,
          text: `确定删除勾选的${len}个客户吗？删除后可在回收站撤回，是否继续？`,
          confirmText: "",
          cancelText: "",
          confirm: function () {
            that.setDeleteRow();
          },
          cancel: function () {

          }
        });
      } else {
        this.$message.warning('至少勾选一行')

      }
    },
    // 单个表格项被选中删除
    rowDel(list) {
      let that = this;
      this.showModal({
        h: this,
        text: "确定删除吗",
        confirmText: "",
        cancelText: "",
        confirm: function () {
          that.selectList = list;
          that.setDeleteRow();
        },
        cancel: function () {
        }
      });
    },

    getHideDataList() {
      getCustomersHideList({
        page: this.hideListParams.page,
        per_page: this.hideListParams.per_page,
      }).then(res => {
        this.hideData = res.model.data
        this.hideListParams.total = res.model.total
      })
    },
    mergeCustomer() {
      this.dialogMergeCustomerBool = true
    },
    doMergeCustomer() {
      postMergeCustomer({
        ids: this.mergeForm.customer_ids,
        id: this.mergeForm.basic_customer_id
      }).then(() => {
        this.initList();
        this.dialogMergeCustomerBool = false
        this.showToast({
          h: this,
          icon: "el-icon-success",
          text: "操作成功",
          duration: 2000
        });
      })
    },

    inputBasicCustomer() {
      const name = this.$refs.customerBasicSelect.selectedLabel
      this.getCustomerSearchOptions(name, 'customerBasicOptions')
    },
    getCustomerSearchOptions(name, option) {
      if (!name) {
        return false
      }
      this.customerTimestamp = new Date().getTime()
      getCustomerSearchOption({name: name, timestamp: this.customerTimestamp}).then(res => {
        if (res.model.timestamp >= this.customerTimestamp)
          this[option] = res.model.data
      })
    },
    getCustomerOption() {
      this.customerOptions = []
      getCustomerOption({}).then(res => {
        let customerOptions = res.model || []
        customerOptions.forEach((item) => {
          this.$set(item, 'custom_value', `${item.name}-${item.id}`)
        })

        this.customerOptions = customerOptions
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.customerMultipleOptions = this.customerOptions.filter(item => {
            return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.customerMultipleOptions = [];
      }
    },
    changeBasicCustomer() {
      const index = this.customerBasicOptions.findIndex(item => {
        return item.id === this.mergeForm.basic_customer_id
      })
      this.mergeForm.basic_customer_name = this.customerBasicOptions[index] ? this.customerBasicOptions[index].name : '-'
    },
    changeMergeCustomers() {
      this.mergeForm.customer_names = this.mergeForm.customers.join(",")
      let ids = [];
      if (Array.isArray(this.mergeForm.customers)) {
        for (let index = 0; index < this.mergeForm.customers.length; index++) {
          const obj = this.mergeForm.customers[index]
          ids.push(obj.substr((obj.lastIndexOf('-') + 1)));
        }
      }
      this.mergeForm.customer_ids = ids
    },
    undoHandle(row) {
      const that = this
      that.showModal({
        h: that,
        text: '确认撤销 “' + row.name + '” 客户的“' + (row.is_deleted ? '删除' : '合并') + '”操作？',
        confirm: function () {
          postUndoHandel({id: row.id, is_deleted: row.is_deleted}).then(() => {
            that.$message.success('操作成功');
            that.initList()
          })
        }
      })
    },
    handleHideListCurrentChange(val) {
      this.hideListParams.page = val
      this.getHideDataList();
    },
    async exportExcel(refName) {
      // this.$message.warning('未开放！！！')
      try {
        // this.$notify.info(refName)
        const searchCondition = this.handleSearchCondition()
        Object.assign(searchCondition, {orderBy: this.orderBy})
        let name = '客户资料'

        const response = await exportCustomers(searchCondition).then(response => {
          return response
        })

        this.$refs[refName].exportSaveXlsx(response, name)

      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
        // alert(JSON.stringify(e))
      }
    },
    async handelRemoteCombine(query) {
      const response = await combineCustomerLikeQuery({value: query})
      this.combineOptions = response.model || []
    },
    handelManageCombine() {
      const {href} = this.$router.resolve({
        name: 'combineCustomer'
      });
      window.open(href, "_blank");
    },
    /**
     * 客户年框详情
     * @param row
     */
    handelToYearFrame(row) {
      const {href} = this.$router.resolve({
        name: 'detailCustom',
        query: {id: row.id, tab: 'YEAR_FRAME'}
      });
      window.open(href, "_blank");
    },
    // 执行公司
    goExecCorp(row) {
      this.dialogExecCorp.loading = true
      if (row.id && row.name) {
        this.dialogExecCorp.show = true
        this.dialogExecCorp.title = row.name
        this.dialogExecCorp.form.customer_id = row.id
        this.getExecCorpList(row.id)
      } else  {
        this.$message.error('请选择客户')
      }
    },
    dialogClosedExecCorp() {
      this.dialogExecCorp.pagingData.total = 0
      this.dialogExecCorp.pagingData.offset = 0
      this.$refs['execCorpTable'].currentPage = 1
      this.dialogExecCorp.form.corp_id = null
      this.dialogExecCorp.form.corp_nm = ''
    },
    // 切换页码操作
    async switchExecCorpPaging() {
      await this.getExecCorpList(this.dialogExecCorp.form.customer_id)
    },
    getExecCorpList(customer_id) {
      this.$nextTick(async () =>{
        const pagingInfo = this.$refs['execCorpTable'].getPagingInfo()
        const data = {customer_id: customer_id, ...pagingInfo}
        const { list, pages } = await getCustomerExecCorpList(data).then(res => {
          return res.model
        })

        this.$nextTick(() => {
          this.dialogExecCorp.data = list
          this.dialogExecCorp.loading = false

        })
        this.dialogExecCorp.pagingData.total = pages.total || 0
        this.dialogExecCorp.pagingData.offset = pages.offset || 0
      })
    },
    async querySearchAsync(queryString) {
      if (queryString) {
        // 获取已绑定的执行公司
        let filterIds = this.dialogExecCorp.data.map(item => item.corp_id)
        // 增加自身公司的id
        filterIds.push(this.dialogExecCorp.form.customer_id)
        // 开始请求接口 开启加载提示
        this.dialogExecCorp.selectLoading = true
        // this.$nextTick(async function () {
        const { model:{ data } } = await customerSearch({search: queryString, filter_ids: filterIds})
        this.dialogExecCorp.selectList = data
        // 请求接口完成 停止加载提示
        this.dialogExecCorp.selectLoading = false
        // })
      } else {
        this.dialogExecCorp.selectList = []
      }
    },
    // 绑定执行公司
    async onSubmitExecCorp() {
      if (!this.dialogExecCorp.form.customer_id) {
        this.showToast({h: this, icon: "el-icon-error", text: '请选择客户', duration: 3000});
        return false
      }
      if (!this.dialogExecCorp.form.corp_id) {
        this.showToast({h: this, icon: "el-icon-error", text: '请选择执行公司', duration: 3000});
        return false
      }
      const response = await storeExecCorp(this.dialogExecCorp.form)
      if (!response.success) {
        this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
        return false;
      }
      this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
      this.dialogExecCorp.form.corp_id = null
      this.dialogExecCorp.form.corp_nm = ''
      await this.getExecCorpList(this.dialogExecCorp.form.customer_id)
    },
    // 删除执行公司
    onDeleteExecCorp(row) {
      this.$confirm('与【' + row.corp_nm + '】的绑定关系即将解除, 是否继续?', '解绑提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const response = await deleteExecCorp({id: row.id})
        if (!response.success) {
          this.$message({
            type: 'error',
            message: '解绑失败!'
          });
          return false;
        } else {
          this.$message({
            type: 'success',
            message: '解绑成功!'
          });
          await this.getExecCorpList(row.customer_id)
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消解绑'
        });
      });
    }
  }
};
</script>
<style scoped>
.line {
  text-align: center;
}

.page-main {
  padding: 10px;
}

.delete-btn {
  color: #F56C6C !important;
}

.corp-btn {
  color: #FF6EB4 !important;
}

.corp-refresh-btn {
  border-color: #67C23A !important;
  background-color: #67C23A !important;
}

.form {
  /*margin-top: 40px;*/
  /*padding-top: 15px;*/
}

.header {
  background: #fff;
  padding: 0px 30px 0 30px;
  border-bottom: 1px solid #F2F2F2;
}

.tableCon {
  background: #fff;
  padding: 22px 30px 0px 30px;
}

.buttons a {
  font-size: 14px;
  font-weight: 400;
  color: rgba(4, 153, 255, 1);
  line-height: 20px;
  margin: 0px 8px;
}

.input-m {
  width: 95%;
}

.default-button {
  padding: 3px 8px;
  /*color: rgb(254, 45, 84);*/
  font-size: 14px;
  border: 1px solid rgb(161, 161, 161);
  border-radius: 2px;
  cursor: pointer;
}
</style>
<style lang="scss">
.el-dialog__header {
  text-align: left;
}

#v-model {
  z-index: 3000 !important;
}

.dialog-store-customer {
  .el-select {
    width: 100%;
  }
}
</style>
